<template>
  <VehiclesForm :typeEndPoint="'schoolRoutesVehiclesForm'" :dataParams="{}"/>
</template>
<script>
import VehiclesForm from '@/components/modules/schoolroutes/vehicles/form'
export default {
  name: 'VehiclesFormCreate',
  components: {
    VehiclesForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/vehicles/create.vue